// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"882":"87adceba","941":"3a22451b"}[chunkId] + ".chunk.js";
};